<template>
  <div>
    <div class="trend container-item">
      <div
        class="header"
        :style="{
          'background-image': `url(${require(`assets/images/bg-squre.png`)})`
        }"
      >
        预警趋势
      </div>
      <div class="body">
        <el-form label-width="80px" class="search">
          <el-row>
            <el-col :span="6">
              <el-form-item label="时间范围">
                <el-date-picker
                  v-model="queryParams.time"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-button type="primary" @click="loadTrendData">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="title">预警趋势图</div>
        <echarts :echartsOption="echartsOption" echartsHeight="377px" />
      </div>
    </div>
    <div class="container">
      <div class="warn container-item">
        <div
          class="header"
          :style="{
            'background-image': `url(${require(`assets/images/bg-circle.png`)})`
          }"
        >
          企业预警查询
        </div>
        <div class="body">
          <ul class="tab1">
            <li
              :class="['tab1-item', { active: tab1Filter === 'all' }]"
              @click="tab1Click('all')"
            >
              <img
                :src="
                  tab1Filter === 'all'
                    ? require('assets/images/all_active.png')
                    : require('assets/images/all.png')
                "
                alt=""
                class="tab1-item-img"
              />
              <span>全部企业</span>
            </li>
            <li
              :class="['tab1-item', { active: tab1Filter === 'production' }]"
              @click="tab1Click('production')"
            >
              <img
                :src="
                  tab1Filter === 'production'
                    ? require('assets/images/pro_active.png')
                    : require('assets/images/pro.png')
                "
                alt=""
                class="tab1-item-img"
              />
              <span>生产企业</span>
            </li>
            <li
              :class="['tab1-item', { active: tab1Filter === 'circulate' }]"
              @click="tab1Click('circulate')"
            >
              <img
                :src="
                  tab1Filter === 'circulate'
                    ? require('assets/images/cir_active.png')
                    : require('assets/images/cir.png')
                "
                class="tab1-item-img"
                alt=""
              />
              <span>流通企业</span>
            </li>
            <li
              :class="['tab1-item', { active: tab1Filter === 'retail' }]"
              @click="tab1Click('retail')"
            >
              <img
                :src="
                  tab1Filter === 'retail'
                    ? require('assets/images/retail_active.png')
                    : require('assets/images/retail.png')
                "
                class="tab1-item-img"
                alt=""
              />
              <span>零售企业</span>
            </li>
          </ul>
          <ul
            class="enterprise-list"
            v-infinite-scroll="loadWarnEnterpriseList"
            infinite-scroll-disabled="enterpriseIsLastPage"
          >
            <li
              class="enterprise-item"
              v-for="(item, index) in warnEnterpriseList"
              :key="index"
              @click="checkWarnEnterpriseDetail(item)"
            >
              <div class="number">{{ index + 1 }}</div>
              <div class="name">{{ item.enterpriseName }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="history container-item">
        <div
          class="header"
          :style="{
            'background-image': `url(${require(`assets/images/bg-rectangle.png`)})`
          }"
        >
          预警事件历史
        </div>
        <div class="body">
          <div class="title">
            <div class="total-count">{{ warnTotalCount }}</div>
            <div class="text">预警总数</div>
          </div>
          <div class="warn-list-container">
            <ul
              class="warn-list"
              v-infinite-scroll="loadWarnHistory"
              infinite-scroll-disabled="historyIsLastPage"
            >
              <li
                class="warn-item"
                v-for="(item, index) in warnHistoryList"
                :key="index"
              >
                <div class="download" @click="download(item)">
                  <img src="~assets/images/download.png" alt="" />
                  <span>下载预警周报</span>
                </div>
                <div class="date">{{ item.weekDate }}</div>
                <div class="week-count">
                  本周预警总数：<span class="count">{{
                    item.totalRiskNum
                  }}</span>
                </div>
                <div class="table-container">
                  <div class="small-title">主要相关企业 TOP 5</div>
                  <el-table
                    :data="item.riskEntTop || []"
                    @row-click="
                      row => {
                        checkHistoryEntDetail(row, item);
                      }
                    "
                    :row-style="rowStyle"
                  >
                    <el-table-column width="80px" type="index" label="排名" />
                    <el-table-column prop="enterpriseName" label="企业名称" />
                    <el-table-column
                      width="107px"
                      prop="abnormalTypeNum"
                      label="预警数量"
                    />
                  </el-table>
                </div>
                <div class="table-container">
                  <div class="small-title">预警分类数量</div>
                  <el-table
                    :data="warnTypeList(item.riskTypeNum)"
                    @row-click="
                      row => {
                        checkHistoryClassifyDetail(row, item);
                      }
                    "
                    :row-style="rowStyle"
                  >
                    <el-table-column prop="type" label="异常分类" />
                    <el-table-column
                      width="107px"
                      prop="num"
                      label="预警数量"
                    />
                  </el-table>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';

export default {
  data() {
    return {
      queryParams: {
        time: ''
      },
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: [
            '证照异常',
            '原辅料异常',
            '生产存储异常&运输异常',
            '进销存异常'
          ],
          bottom: '30px',
          textStyle: {
            color: '#666666'
          }
        },
        grid: {
          top: '20px',
          left: '3%',
          right: '4%',
          bottom: '70px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLabel: {
              color: '#999999'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLabel: {
              color: '#999999'
            }
          }
        ],
        series: [
          {
            name: '证照异常',
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: '#FFB439'
            },
            itemStyle: {
              color: '#FFB439'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#FFB439'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '原辅料异常',
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: '#2BBF99'
            },
            itemStyle: {
              color: '#2BBF99'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#2BBF99'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '生产存储异常&运输异常',
            type: 'line',
            stack: '总量',
            itemStyle: {
              color: '#386CE2'
            },
            lineStyle: {
              color: '#386CE2'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#386CE2'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '进销存异常',
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: '#CEDBEF'
            },
            itemStyle: {
              color: '#CEDBEF'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#CEDBEF'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: [320, 332, 301, 334, 390, 330, 320]
          }
        ]
      },
      tab1Filter: 'all',
      enterpriseIsLastPage: false,
      warnEnterprisePageNum: 0,
      warnEnterpriseList: [],
      historyIsLastPage: false,
      historyPageNum: 0,
      warnHistoryList: [],
      warnTotalCount: 0
    };
  },
  mounted() {
    this.loadTrendData();
    const contentContainer = document.getElementsByClassName(
      'content-container'
    )[0];
    contentContainer.style.paddingBottom = '0px';
  },
  beforeDestroy() {
    const contentContainer = document.getElementsByClassName(
      'content-container'
    )[0];
    contentContainer.style.paddingBottom = '80px';
  },
  methods: {
    loadTrendData() {
      const time = this.queryParams.time;
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnTrendStatistics',
        data: {
          json: JSON.stringify({
            params: {
              createEndTime: time ? time[1] : '',
              createStartTime: time ? time[0] : '',
              enterpriseName: ''
            }
          })
        }
      }).then(res => {
        const xData = Object.keys(res);
        const yData = Object.values(res);
        const riskEntData = [];
        const riskYclData = [];
        const riskScData = [];
        const riskJxcData = [];
        yData.forEach(item => {
          riskEntData.push(item.riskEntNum);
          riskYclData.push(item.riskYclNum);
          riskScData.push(item.riskScNum);
          riskJxcData.push(item.riskJxcNum);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = riskEntData;
        this.echartsOption.series[1].data = riskYclData;
        this.echartsOption.series[2].data = riskScData;
        this.echartsOption.series[3].data = riskJxcData;
      });
    },
    loadWarnEnterpriseList() {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnEntStatistics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.warnEnterprisePageNum++,
              pageSize: 10
            },
            params: {
              entType: this.$common.entType[this.tab1Filter] || ''
            }
          })
        }
      }).then(res => {
        this.enterpriseIsLastPage = res.isLastPage;
        if (res.list.length > 0) {
          this.warnEnterpriseList = this.warnEnterpriseList.concat(res.list);
        }
      });
    },
    loadWarnHistory() {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnHistoryStatistics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.historyPageNum++,
              pageSize: 5
            },
            params: {}
          })
        }
      }).then(res => {
        this.warnTotalCount = res.totalNum;
        this.historyIsLastPage = res.pageInfo.isLastPage;
        this.warnHistoryList = this.warnHistoryList.concat(res.pageInfo.list);
      });
    },
    tab1Click(type) {
      this.warnEnterprisePageNum = 0;
      this.warnEnterpriseList = [];
      this.tab1Filter = type;
      this.loadWarnEnterpriseList();
    },
    warnTypeList(obj) {
      const { riskEntNum, riskJxcNum, riskScNum, riskYclNum } = obj;
      return [
        { type: '证照异常', num: riskEntNum || 0 },
        { type: '进销存异常', num: riskJxcNum || 0 },
        { type: '生产存储异常&&仓储运输异常', num: riskScNum || 0 },
        { type: '原辅料异常', num: riskYclNum || 0 }
      ];
    },
    checkWarnEnterpriseDetail(item) {
      this.$router.push({
        path: `/page/monitorOverview/enterpriseDetail/${item.enterpriseName}`
      });
    },
    // top5点击查看详情
    checkHistoryEntDetail(row, item) {
      this.$router.push({
        path: `/page/monitorOverview/historyDetail?enterpriseName=${row.enterpriseName}&currentWeek=${item.currentWeek}&currentYear=${item.currentYear}&weekDate=${item.weekDate}`
      });
    },
    // 异常分类点击查看详情
    checkHistoryClassifyDetail(row, item) {
      this.$router.push({
        path: `/page/monitorOverview/historyDetail?warnType=${row.type}&currentWeek=${item.currentWeek}&currentYear=${item.currentYear}&weekDate=${item.weekDate}`
      });
    },
    rowStyle({ row, rowIndex }) {
      return { cursor: 'pointer' };
    },
    download(item) {
      window.location.href = `http://gagcheck.dev.goago.cn/open/riskwarning/downLoadRiskWeek?currentWeek=${item.currentWeek}&currentYear=${item.currentYear}`;
    }
  },
  components: {
    Echarts
  }
};
</script>

<style lang="stylus" scoped>
.container-item
  margin-bottom 21px
  .header
    background-size cover
    height 74px
    line-height 60px
    padding-left 21px
    font-size 18px
    border-radius 8px 8px 0 0
    color #fff
  .body
    position relative
    background #fff
    border-radius 8px
    transform translate(0, -16px)
    overflow hidden
    padding 0 20px
    .search
      margin 30px 0
.trend
  color #000
  .body
    .title
      border-bottom 1px solid rgba(206,219,239, .5)
      line-height 30px
      font-size 14px
.container
  color #000
  display flex
  .container-item
    flex 1
    &.warn
      margin-right 10px
      .tab1
        line-height 48px
        border-bottom 1px solid rgba(206,219,239,0.5)
        border-top 1px solid rgba(206,219,239,0.5)
        display flex
        margin-top 14px
        .tab1-item
          padding 0 20px
          display flex
          align-items center
          border-right 1px solid rgba(206,219,239,0.5)
          cursor pointer
          flex 1
          &:last-child
            border 0
          &.active
            color #386ce2
          .tab1-item-img
            width 18px
            margin-right 10px
      .enterprise-list
        margin-top 20px
        height 618px
        overflow-y auto
        .enterprise-item
          display flex
          text-align center
          line-height 29px
          height 29px
          padding 12px 0
          background rgba(207,220,239,.5)
          margin-bottom 14px
          cursor pointer
          .number
            width 129px
            font-size 20px
            color #999999
            border-right 1px solid #CEDBEF
          .name
            flex 1
            font-size 14px
            color #386CE2
    &.history
      margin-left 10px
      .body
        .title
          padding 13px 0
          text-align center
          border-bottom 1px solid #CEDBEF
          .total-count
            font-size 20px
            color #3D72EA
          .text
            color #666666
            font-size 12px
        .warn-list-container
          height 634px
          overflow-y auto
          .warn-list
            background-image url('../images/step-bg.png')
            background-repeat-x no-repeat
            background-size 14px 513px
            .warn-item
              margin-top 15px
              padding-left 55px
              overflow hidden
              position relative
              .download
                position absolute
                top 27px
                right 20px
                font-size 12px
                display flex
                align-items center
                color #386CE2
                cursor pointer
                img
                  width 13px
                  height 12px
                  margin-right 3px
              .date
                font-size 18px
                color #666666
              .week-count
                font-size 12px
                line-height 20px
                .count
                  font-size 13px
                  color #3D72EA
              .table-container
                margin-top 20px
                .small-title
                  font-size 12px
                  margin-bottom 8px
</style>
